import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { useKeycloak } from '@react-keycloak/web'
import { Launch, Remove } from '@material-ui/icons/'
import MapComponent from './MapComponent/MapComponent'
import HeadBar from './HeadBar/HeadBar'
import SelectSearchType from './Custom/SelectSearchType/SelectSearchType'
import GetPropertySuggestion from './Custom/GetPropertySuggestion/GetPropertySuggestion'
import GetProspectingSuggestion from './Custom/GetProspectingSuggestion/GetProspectingSuggestion'
import FiltersComponent from './FiltersComponent/FiltersComponent/FiltersComponent'
// import FetchData from './FetchData/FetchData'
import '../../Styles/habitat-global.css'
import PreSearchFilter from './FiltersComponent/PreSearchFilter/PreSearchFilter.js'
import getSearchFields from './FiltersComponent/SearchFields/SearchFields'
import getSearchCriteria from './FiltersComponent/SearchCriteria/SearchCriteria'
import getPreSearchCriteria from './FiltersComponent/PreSearchCriteria/PreSearchCriteria'
import getSavedSearch from './Utility/GetSavedSearch/GetSavedSearch'
import { ThingsProvider } from './FiltersComponent/context/context'
import './FiltersComponent/AddedStyles.css'
import SearchResultTable from './SearchResultTable/SearchResultTable'
import { isFilterApplied, getQueryStringValue } from './Utility/Utility.js'
import Alert from '../../Components/Common/Alert/Alert'
// import { AuthContext } from '../../context/AuthContext'
import SidebarMenu from './Sidebar/SidebarMenu/SidebarMenu'
// import SavedPage from './Sidebar/Saved/Saved'
import PropertyList from '../PropertyList/PropertyList'
import LoadingSpinner from '../Common/LoadingSpinner/LoadingSpinner'
import SelectExistingSearch from '../PropertySearch/HeadBar/SelectExistingSearch/SelectExistingSearch'
import SelectExistingList from '../PropertySearch/HeadBar/SelectExistingList/SelectExistingList'

const PropertySearch = () => {
  const defaultMessage = 'Please wait, your request is being processed.'

  const [showSpinner, setShowSpinner] = useState(false)
  const [searchFields, setSearchFields] = useState(getSearchFields)
  const [searchCriteria, setSearchCriteria] = useState(getSearchCriteria)
  const [preSearchCriteria, setPreSearchCriteria] = useState(getPreSearchCriteria)
  const [searchResult, setSearchResult] = useState({ property: [], totalCount: 0 })
  const [savedSearch, setSavedSearch] = useState([])
  const [savedLists, setSavedLists] = useState([])
  const [isOnLoad, setIsOnLoad] = useState(true)
  const [showAlert, setShowAlert] = useState(false)
  const [alertProps, setalertProps] = useState({ message: '', type: '' })
  const [showMap, setShowMap] = useState(false)
  const [refreshSavedSearch, setRefreshSavedSearch] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState('')
  const [savedSearchLoading, setSavedSearchLoading] = useState(true)
  const [savedListsLoading, setSavedListsLoading] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [warningMessage, setWarningMessage] = useState(defaultMessage)
  // const keycloak = useContext(AuthContext)
  const { keycloak, initialized } = useKeycloak()
  const [infoWindowToShow, setInfoWindowToShow] = useState('')

  document.body.classList.add('disable-scrollbars')
  document.body.classList.add('bg-white')

  // Dont remove below code
  // const paramValue = getUserSFId()
  // console.log('userId :: ', paramValue)

  React.useEffect(() => {
    // console.log('keycloak.authenticated:: 1')
    // setupPath()
    // window.addEventListener('mousemove', onPageLoad, true)
    // window.addEventListener('ontouchstart', onPageLoad, true)
    if (isOnLoad && keycloak.authenticated) {
      updateSelectedMenu()
      setIsOnLoad(false)
      fetchSavedSearch()
      fetchSavedLists()
      loadMarkerclusterer()
      // fetchSavedListsAfterDML()
    }
  }, [keycloak.authenticated])

  const updateSelectedMenu = () => {
    let pathname = window.location.pathname
    const href = window.location.href
    let queryParam = href.split('?')[1] ? '?' + href.split('?')[1] : ''
    let view = getQueryStringValue('view') ? getQueryStringValue('view') : ''
    pathname = pathname.toLowerCase()
    if (pathname.includes('propertylist') && queryParam.includes('&list_id=')) {
      setSelectedMenu('list')
    } else {
      // setSelectedMenu('search')
      switch (view) {
        case 'search':
          setSelectedMenu('search')
          break
        case 'savedList':
          setSelectedMenu('savedList')
          break
        case 'savedSearch':
          setSelectedMenu('savedSearch')
          break
        default:
          setSelectedMenu('search')
          break
      }
    }
  }

  // const onPageLoad = () => {
  //   if (isOnLoad && keycloak.authenticated) {
  //     console.log('keycloak.authenticated:: ', keycloak.authenticated)
  //     window.removeEventListener('mousemove', onPageLoad, true)
  //     window.removeEventListener('ontouchstart', onPageLoad, true)
  //     setIsOnLoad(false)
  //     fetchSavedSearch()
  //     loadMarkerclusterer()
  //   }
  // }

  // const setupPath = () => {
  //   let pathname = window.location.pathname
  //   pathname = pathname.toLowerCase()
  //   let menuItem = pathname.includes('/propertylists') ? 'list' : selectedMenu
  //   // menuItem = pathname.includes('/PropertySearch') ? 'savedsearch' : menuItem
  //   setSelectedMenu(menuItem)
  // }
  const customStyles = {
    content: {
      top: '30%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -40%)',
      padding: '10px'
    },
    overlay: { zIndex: 1050 }
  }

  useEffect(() => {
    if (!isOnLoad) {
      fetchSavedSearch()
      fetchSavedLists()
    }
  }, [refreshSavedSearch])

  // useEffect(() => {
  //   if (savedLists.length > 0) {
  //     fetchPropertyPhotos()
  //   }
  // }, [savedLists])

  const fetchSavedSearch = async () => {
    const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch, !isOnLoad)
    await getSavedSearchObj.fetchSavedSearch()
    setSavedSearchLoading(false)
    fetchSavedSearchAfterDML()
  }

  const fetchSavedLists = async () => {
    const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch, !isOnLoad)
    await getSavedSearchObj.fetchSavedLists()
    setSavedListsLoading(false)
    fetchSavedListsAfterDML()
  }

  const fetchSavedListsAfterDML = async () => {
    let count = 1
    do {
      await new Promise(resolve => setTimeout(resolve, 5000));
      const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch, !isOnLoad)
      await getSavedSearchObj.fetchSavedLists()
      count++;
    } while (count < 3)
  }

  const fetchSavedSearchAfterDML = async () => {
    if (!isOnLoad) {
      let count = 1
      do {
        await new Promise(resolve => setTimeout(resolve, 2000));
        const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch, !isOnLoad)
        await getSavedSearchObj.fetchSavedSearch()
        count++;
      } while (count < 3)
    }
  }

  // const fetchPropertyPhotos = async () => {
  //   const getSavedSearchObj = new getSavedSearch(setSavedLists, setSavedSearch)
  //   let newSavedLists = await getSavedSearchObj.getPropertyPhotos(savedLists)
  //   setSavedLists(newSavedLists)
  // }

  const loadMarkerclusterer = () => {
    const script = document.createElement('script')
    // script.src = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js'
    script.src = 'https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js'
    script.async = true
    document.body.appendChild(script)
  }

  function closeModal() {
    if (!openModal)
      setOpenModal(false)
  }

  const openModalWindow = (state, msg = defaultMessage) => {
    setWarningMessage(msg)
    setOpenModal(state)
  }

  return (
    <>
      <ThingsProvider value={{
        savedLists, setSavedLists, searchFields, setSearchFields, searchCriteria,
        setSearchCriteria, preSearchCriteria, savedSearch, setSavedSearch, infoWindowToShow, setInfoWindowToShow,
        setPreSearchCriteria, setShowSpinner, searchResult, setSearchResult, showAlert, setShowAlert,
        setalertProps, selectedMenu, setSelectedMenu, showMap, refreshSavedSearch, setRefreshSavedSearch,
        fetchSavedSearch, fetchSavedLists, openModalWindow
      }}>
        {(showSpinner || isOnLoad) && <LoadingSpinner></LoadingSpinner>}
        <Modal ariaHideApp={false} isOpen={openModal} onRequestClose={closeModal}
          closeTimeoutMS={500} style={customStyles} >
          <div data-testid="test-common-modal" className='flex flex-row items-center space-x-2'>
            <label className='text-1 pr-2'>{warningMessage}</label>
            <span className="loader h-6 w-6 mx-2" ></span>
          </div>
        </Modal>
        {selectedMenu !== 'list' &&
          <header style={{ height: 56 }} className="text-white col-span-3 theme-dark overflow-hidden sticky-top z-sticky">
            <HeadBar view={selectedMenu} ></HeadBar>
          </header>}
        {showAlert && <Alert config={alertProps} />}
        <div className="w-full flex flex-row">
          {selectedMenu !== 'list' &&
            <div style={{ 'zIndex': '1 !important', 'top': '58px' }} className="h-screen-75 border-1 border-base p-2 sticky-top">
              <SidebarMenu></SidebarMenu>
            </div>}
          {selectedMenu === 'search' && <div className="w-full" data-testid="test-search-page">
            <div className="grid grid-cols-6">
              <div className={`${showMap ? 'col-span-4' : 'col-span-6 md:col-span-5'}`}>
                <div className="flex flex-col w-full">
                  <div className="flex flex-col md:flex-row p-3">
                    <div className="w-full md:w-2/5">
                      <SelectSearchType />
                    </div>
                    <div className="px-4 pt-2 w-full md:w-3/5">
                      <div className={`w-full rounded-pill badge inline-flex items-center border-1 border-base rounded divide-base divide-x-1 align-middle ${searchCriteria.subjectProperty.omniViewPropertyId && preSearchCriteria.searchType !== 'prospecting' ? 'bg-gray-10' : 'bg-white'}`} >
                        <div className="flex-grow">
                          {preSearchCriteria.searchType === 'prospecting' ?
                            <GetProspectingSuggestion data-testid="test-prospecting-component" />
                            : <GetPropertySuggestion data-testid="test-suggestion-component" />}
                        </div>
                        <div>
                          <PreSearchFilter></PreSearchFilter>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <FiltersComponent />
                    {/* <HButton ariaLabel="Submit" btntype="submit" disabled="false" href="https://google.com" rounded="true" size="lg" variation="primary" > Submit </HButton> */}
                  </div>
                </div>
              </div>
              <div className={`p-4 hidden md:block ${showMap ? 'col-span-2 row-span-2' : 'col-span-1 h-11'}`} >
                <div className="flex flex-col h-full relative">
                  <div style={{ 'zIndex': '1' }} className="absolute right-0 mt-2 mr-2">
                    <button title={`${showMap ? 'Minimize Map' : 'Expand Map'}`} className="btn text-primary text-1 btn-sm bg-white shadow-1" data-testid="test-toggle-map" onClick={() => setShowMap(!showMap)}>
                      {showMap ? <Remove fontSize="small" /> : <Launch fontSize="small" />}
                    </button>
                  </div>
                  <div style={{ 'zIndex': '0' }} className={`${showMap ? 'h-screen-75' : 'h-full'}`}>
                    <MapComponent fullHeight={showMap} propertyList={searchResult.property} showCluster={true} />
                  </div>
                </div>
              </div>
              <div className={`px-4 ${showMap ? 'col-span-4' : 'col-span-6'}`}>
                {isFilterApplied(searchCriteria) && searchResult.property.length === 0 ? 'Search returned 0 result' : null}
                {searchResult.property.length > 0 ? <SearchResultTable /> : null}
                {/* <FetchData /> */}
              </div>
              <div className="block md:hidden h-screen-75 col-span-6 px-4">
                <MapComponent fullHeight={showMap} propertyList={searchResult.property} showCluster={true} />
              </div>
            </div>
          </div>}
          {selectedMenu === 'savedList' && <div className="w-full px-4 pt-4">
            {savedListsLoading && <LoadingSpinner></LoadingSpinner>}
            <SelectExistingList view="select"></SelectExistingList>
          </div>}
          {selectedMenu === 'savedSearch' && <div className="w-full px-4 pt-4">
            {savedSearchLoading && <LoadingSpinner></LoadingSpinner>}
            <SelectExistingSearch view="select"></SelectExistingSearch>
          </div>}
          {/* {selectedMenu === 'saved' && <div className="w-full px-4 pt-4">
            <SavedPage savedSearchLoading={savedSearchLoading} setSavedSearchLoading={setSavedSearchLoading} ></SavedPage>
          </div>} */}
          {selectedMenu === 'list' && <div className="w-full" data-testid="test-list-component">
            <PropertyList></PropertyList>
          </div>}

        </div>
      </ThingsProvider>
    </>
  )
}

export default PropertySearch
